var _objectSpread = require("/var/www/repository/Production-Zocial-AdminPanel/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _asyncToGenerator = require("/var/www/repository/Production-Zocial-AdminPanel/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");
var _awaitAsyncGenerator = require("/var/www/repository/Production-Zocial-AdminPanel/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");
var _wrapAsyncGenerator = require("/var/www/repository/Production-Zocial-AdminPanel/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _asyncIterator(r) { var n, t, o, e = 2; for ("undefined" != typeof Symbol && (t = Symbol.asyncIterator, o = Symbol.iterator); e--;) { if (t && null != (n = r[t])) return n.call(r); if (o && null != (n = r[o])) return new AsyncFromSyncIterator(n.call(r)); t = "@@asyncIterator", o = "@@iterator"; } throw new TypeError("Object is not async iterable"); }
function AsyncFromSyncIterator(r) { function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) return Promise.reject(new TypeError(r + " is not an object.")); var n = r.done; return Promise.resolve(r.value).then(function (r) { return { value: r, done: n }; }); } return AsyncFromSyncIterator = function AsyncFromSyncIterator(r) { this.s = r, this.n = r.next; }, AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(r) { var n = this.s.return; return void 0 === n ? Promise.resolve({ value: r, done: !0 }) : AsyncFromSyncIteratorContinuation(n.apply(this.s, arguments)); }, throw: function _throw(r) { var n = this.s.return; return void 0 === n ? Promise.reject(r) : AsyncFromSyncIteratorContinuation(n.apply(this.s, arguments)); } }, new AsyncFromSyncIterator(r); }
var defer = require('p-defer');
var Headers = require('./extract-headers');
var LteReader = require('./lte-reader');
function getPadding(size) {
  size &= 511;
  return size && 512 - size;
}
function discardPadding(_x, _x2) {
  return _discardPadding.apply(this, arguments);
}
function _discardPadding() {
  _discardPadding = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(reader, size) {
    var overflow;
    return _regeneratorRuntime().wrap(function _callee4$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          overflow = getPadding(size);
          if (!overflow) {
            _context5.next = 4;
            break;
          }
          _context5.next = 4;
          return reader.next(overflow);
        case 4:
        case "end":
          return _context5.stop();
      }
    }, _callee4);
  }));
  return _discardPadding.apply(this, arguments);
}
module.exports = function (options) {
  options = options || {};
  options.highWaterMark = options.highWaterMark || 1024 * 16;
  return function (source) {
    return _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      var reader, gnuLongPath, gnuLongLinkPath, paxGlobal, pax, _loop, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _ret;
      return _regeneratorRuntime().wrap(function _callee3$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            reader = LteReader(source);
            _context4.prev = 1;
            _loop = /*#__PURE__*/_regeneratorRuntime().mark(function _loop() {
              var headerBytes, _yield$_awaitAsyncGen, done, value, header, _yield$_awaitAsyncGen2, _done, gnuLongPathBytes, _yield$_awaitAsyncGen3, _done2, gnuLongLinkPathBytes, _yield$_awaitAsyncGen4, _done3, paxGlobalBytes, _yield$_awaitAsyncGen5, _done4, paxBytes, bytesRemaining, bodyConsumed, firstChunk, body, _;
              return _regeneratorRuntime().wrap(function _loop$(_context3) {
                while (1) switch (_context3.prev = _context3.next) {
                  case 0:
                    _context3.prev = 0;
                    _context3.next = 3;
                    return _awaitAsyncGenerator(reader.next(512));
                  case 3:
                    _yield$_awaitAsyncGen = _context3.sent;
                    done = _yield$_awaitAsyncGen.done;
                    value = _yield$_awaitAsyncGen.value;
                    if (!done) {
                      _context3.next = 8;
                      break;
                    }
                    return _context3.abrupt("return", {
                      v: void 0
                    });
                  case 8:
                    headerBytes = value;
                    _context3.next = 16;
                    break;
                  case 11:
                    _context3.prev = 11;
                    _context3.t0 = _context3["catch"](0);
                    if (!(_context3.t0.code === 'ERR_UNDER_READ')) {
                      _context3.next = 15;
                      break;
                    }
                    return _context3.abrupt("return", {
                      v: void 0
                    });
                  case 15:
                    throw _context3.t0;
                  case 16:
                    header = Headers.decode(headerBytes, options.filenameEncoding);
                    if (header) {
                      _context3.next = 19;
                      break;
                    }
                    return _context3.abrupt("return", 0);
                  case 19:
                    if (!(header.type === 'gnu-long-path')) {
                      _context3.next = 31;
                      break;
                    }
                    _context3.next = 22;
                    return _awaitAsyncGenerator(reader.next(header.size));
                  case 22:
                    _yield$_awaitAsyncGen2 = _context3.sent;
                    _done = _yield$_awaitAsyncGen2.done;
                    gnuLongPathBytes = _yield$_awaitAsyncGen2.value;
                    if (!_done) {
                      _context3.next = 27;
                      break;
                    }
                    return _context3.abrupt("return", {
                      v: void 0
                    });
                  case 27:
                    gnuLongPath = Headers.decodeLongPath(gnuLongPathBytes, options.filenameEncoding);
                    _context3.next = 30;
                    return _awaitAsyncGenerator(discardPadding(reader, header.size));
                  case 30:
                    return _context3.abrupt("return", 0);
                  case 31:
                    if (!(header.type === 'gnu-long-link-path')) {
                      _context3.next = 43;
                      break;
                    }
                    _context3.next = 34;
                    return _awaitAsyncGenerator(reader.next(header.size));
                  case 34:
                    _yield$_awaitAsyncGen3 = _context3.sent;
                    _done2 = _yield$_awaitAsyncGen3.done;
                    gnuLongLinkPathBytes = _yield$_awaitAsyncGen3.value;
                    if (!_done2) {
                      _context3.next = 39;
                      break;
                    }
                    return _context3.abrupt("return", {
                      v: void 0
                    });
                  case 39:
                    gnuLongLinkPath = Headers.decodeLongPath(gnuLongLinkPathBytes, options.filenameEncoding);
                    _context3.next = 42;
                    return _awaitAsyncGenerator(discardPadding(reader, header.size));
                  case 42:
                    return _context3.abrupt("return", 0);
                  case 43:
                    if (!(header.type === 'pax-global-header')) {
                      _context3.next = 55;
                      break;
                    }
                    _context3.next = 46;
                    return _awaitAsyncGenerator(reader.next(header.size));
                  case 46:
                    _yield$_awaitAsyncGen4 = _context3.sent;
                    _done3 = _yield$_awaitAsyncGen4.done;
                    paxGlobalBytes = _yield$_awaitAsyncGen4.value;
                    if (!_done3) {
                      _context3.next = 51;
                      break;
                    }
                    return _context3.abrupt("return", {
                      v: void 0
                    });
                  case 51:
                    paxGlobal = Headers.decodePax(paxGlobalBytes, options.filenameEncoding);
                    _context3.next = 54;
                    return _awaitAsyncGenerator(discardPadding(reader, header.size));
                  case 54:
                    return _context3.abrupt("return", 0);
                  case 55:
                    if (!(header.type === 'pax-header')) {
                      _context3.next = 68;
                      break;
                    }
                    _context3.next = 58;
                    return _awaitAsyncGenerator(reader.next(header.size));
                  case 58:
                    _yield$_awaitAsyncGen5 = _context3.sent;
                    _done4 = _yield$_awaitAsyncGen5.done;
                    paxBytes = _yield$_awaitAsyncGen5.value;
                    if (!_done4) {
                      _context3.next = 63;
                      break;
                    }
                    return _context3.abrupt("return", {
                      v: void 0
                    });
                  case 63:
                    pax = Headers.decodePax(paxBytes, options.filenameEncoding);
                    if (paxGlobal) pax = _objectSpread({}, paxGlobal, pax);
                    _context3.next = 67;
                    return _awaitAsyncGenerator(discardPadding(reader, header.size));
                  case 67:
                    return _context3.abrupt("return", 0);
                  case 68:
                    if (gnuLongPath) {
                      header.name = gnuLongPath;
                      gnuLongPath = null;
                    }
                    if (gnuLongLinkPath) {
                      header.linkname = gnuLongLinkPath;
                      gnuLongLinkPath = null;
                    }
                    if (pax) {
                      if (pax.path) header.name = pax.path;
                      if (pax.linkpath) header.linkname = pax.linkpath;
                      if (pax.size) header.size = parseInt(pax.size, 10);
                      header.pax = pax;
                      pax = null;
                    }
                    if (!(!header.size || header.type === 'directory')) {
                      _context3.next = 75;
                      break;
                    }
                    _context3.next = 74;
                    return {
                      header: header,
                      body: _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
                        return _regeneratorRuntime().wrap(function _callee$(_context) {
                          while (1) switch (_context.prev = _context.next) {
                            case 0:
                            case "end":
                              return _context.stop();
                          }
                        }, _callee);
                      }))()
                    };
                  case 74:
                    return _context3.abrupt("return", 0);
                  case 75:
                    bytesRemaining = header.size;
                    bodyConsumed = defer(); // Prefetch the first chunk.
                    // This allows us to stream entries for small files from the tar without
                    // explicitly streaming the body of each.
                    _context3.next = 79;
                    return _awaitAsyncGenerator(reader.nextLte(Math.min(bytesRemaining, options.highWaterMark)));
                  case 79:
                    firstChunk = _context3.sent;
                    bytesRemaining -= firstChunk.value.length;
                    if (!bytesRemaining) bodyConsumed.resolve();
                    body = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
                      var _yield$_awaitAsyncGen6, _done5, _value;
                      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
                        while (1) switch (_context2.prev = _context2.next) {
                          case 0:
                            _context2.prev = 0;
                            _context2.next = 3;
                            return firstChunk.value;
                          case 3:
                            if (!bytesRemaining) {
                              _context2.next = 17;
                              break;
                            }
                            _context2.next = 6;
                            return _awaitAsyncGenerator(reader.nextLte(bytesRemaining));
                          case 6:
                            _yield$_awaitAsyncGen6 = _context2.sent;
                            _done5 = _yield$_awaitAsyncGen6.done;
                            _value = _yield$_awaitAsyncGen6.value;
                            if (!_done5) {
                              _context2.next = 12;
                              break;
                            }
                            bytesRemaining = 0;
                            return _context2.abrupt("return");
                          case 12:
                            bytesRemaining -= _value.length;
                            _context2.next = 15;
                            return _value;
                          case 15:
                            _context2.next = 3;
                            break;
                          case 17:
                            _context2.prev = 17;
                            bodyConsumed.resolve();
                            return _context2.finish(17);
                          case 20:
                          case "end":
                            return _context2.stop();
                        }
                      }, _callee2, null, [[0,, 17, 20]]);
                    }))();
                    _context3.next = 85;
                    return {
                      header: header,
                      body: body
                    };
                  case 85:
                    _context3.next = 87;
                    return _awaitAsyncGenerator(bodyConsumed.promise);
                  case 87:
                    if (!bytesRemaining) {
                      _context3.next = 115;
                      break;
                    }
                    _iteratorAbruptCompletion = false;
                    _didIteratorError = false;
                    _context3.prev = 90;
                    _iterator = _asyncIterator(body);
                  case 92:
                    _context3.next = 94;
                    return _awaitAsyncGenerator(_iterator.next());
                  case 94:
                    if (!(_iteratorAbruptCompletion = !(_step = _context3.sent).done)) {
                      _context3.next = 99;
                      break;
                    }
                    _ = _step.value;
                  case 96:
                    _iteratorAbruptCompletion = false;
                    _context3.next = 92;
                    break;
                  case 99:
                    _context3.next = 105;
                    break;
                  case 101:
                    _context3.prev = 101;
                    _context3.t1 = _context3["catch"](90);
                    _didIteratorError = true;
                    _iteratorError = _context3.t1;
                  case 105:
                    _context3.prev = 105;
                    _context3.prev = 106;
                    if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
                      _context3.next = 110;
                      break;
                    }
                    _context3.next = 110;
                    return _awaitAsyncGenerator(_iterator.return());
                  case 110:
                    _context3.prev = 110;
                    if (!_didIteratorError) {
                      _context3.next = 113;
                      break;
                    }
                    throw _iteratorError;
                  case 113:
                    return _context3.finish(110);
                  case 114:
                    return _context3.finish(105);
                  case 115:
                    _context3.next = 117;
                    return _awaitAsyncGenerator(discardPadding(reader, header.size));
                  case 117:
                  case "end":
                    return _context3.stop();
                }
              }, _loop, null, [[0, 11], [90, 101, 105, 115], [106,, 110, 114]]);
            });
          case 3:
            if (!true) {
              _context4.next = 12;
              break;
            }
            return _context4.delegateYield(_loop(), "t0", 5);
          case 5:
            _ret = _context4.t0;
            if (!(_ret === 0)) {
              _context4.next = 8;
              break;
            }
            return _context4.abrupt("continue", 3);
          case 8:
            if (!_ret) {
              _context4.next = 10;
              break;
            }
            return _context4.abrupt("return", _ret.v);
          case 10:
            _context4.next = 3;
            break;
          case 12:
            _context4.prev = 12;
            _context4.next = 15;
            return _awaitAsyncGenerator(reader.return());
          case 15:
            return _context4.finish(12);
          case 16:
          case "end":
            return _context4.stop();
        }
      }, _callee3, null, [[1,, 12, 16]]);
    }))();
  };
};